export enum MuxPlaybackPolicy {
	public = 'public',
	signed = 'signed',
	drm = 'drm',
}